export enum TcListDisplayColumnType {
  Date = 'date',
  Html = 'html',
  Currency = 'currency',
  Percent = 'percent',
  Number = 'number',
}
